import { MoreHorizontal } from "lucide-react";

import { Button } from "@ui/button";
import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarSeparator,
  MenubarTrigger,
} from "@ui/menubar";
import { cn } from "@utils/lib/utils";
import { ScrollArea } from "@ui/scroll-area";

type MenuItem = {
  key: string;
  value: string | JSX.Element;
  action?: (key: string, index: number) => void;
};

interface MenuProps {
  items: MenuItem[];
  label?: string | JSX.Element;
  contentClassName?: string;
}

export const Menu = ({ items, label, contentClassName }: MenuProps) => {
  const renderItems = () => {
    return items.map((t, i) => {
      return (
        <div key={t.key}>
          <MenubarItem
            inset={true}
            className="flex cursor-pointer items-center justify-between px-3 py-2"
            onClick={() => {
              t.action && t.action(t.key, i);
            }}
          >
            {t.value}
          </MenubarItem>
          {i !== items.length - 1 ? <MenubarSeparator /> : null}
        </div>
      );
    });
  };

  return (
    <Menubar className="border-none bg-transparent" dir="rtl">
      <MenubarMenu>
        <MenubarTrigger
          asChild
          className="cursor-pointer rounded-none focus:bg-transparent focus-visible:ring-0 data-[state=open]:bg-transparent"
        >
          {label || (
            <Button variant="basic" className="bg-transparent">
              <MoreHorizontal size={25} />
            </Button>
          )}
        </MenubarTrigger>
        <MenubarContent
          align="end"
          className={cn(
            "bg-[#F9F9F9] text-[#898A8D] dark:bg-[#4F5056] dark:text-white",
            contentClassName
          )}
        >
          <ScrollArea className="h-full" dir={"-" as any}>
            {renderItems()}
          </ScrollArea>
        </MenubarContent>
      </MenubarMenu>
    </Menubar>
  );
};
